import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { MailingListsApi } from '../../api/mailingLists/mailingLists.api';
import { MailingListsService } from './services/mailing-lists.service';
import { MailingListPickerComponent } from './components/MailingListPicker/mailing-list-picker.component';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { ManageMailingListsDialogComponent } from './components/ManageMailingListsDialog/manage-mailing-lists-dialog.component';
import { MiscModule } from '../Misc/misc.module';
import { EditRecipientDialogComponent } from './components/EditRecipientDialog/edit-recipient-dialog.component';
import { ImportRecipientsDialogComponent } from './components/ImportRecipientsDialog/import-recipients-dialog.component';
import { CommonBasicModule } from '../Basic/basic.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TooltipModule } from 'primeng/tooltip';
import { TakeOverModule } from '../TakeOver/take-over.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        LocalizationModule,
        CommonFormsModule,
        CoreDialogsModule,
        MiscModule,
        CommonBasicModule,
        AutoCompleteModule,
        TooltipModule,
        TakeOverModule
    ],
    declarations: [
        MailingListPickerComponent,
        ManageMailingListsDialogComponent,
        EditRecipientDialogComponent,
        ImportRecipientsDialogComponent
    ],
    exports: [
        MailingListPickerComponent
    ],
    providers: [
        MailingListsApi,
        MailingListsService
    ]
})
export class MailingListsModule {}
